import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  ErrorMessage as FormikErrorMessage,
  Field as FormikField,
} from "formik";
import { forwardRef, useRef, useState } from "react";
import styles from "./ClickFileInput.module.scss";

const ClickFileInputWithFormik = forwardRef(
  ({ name, withFormik, validate, onChange, ...otherProps }, ref) => {
    if (withFormik) {
      return (
        <div>
          <FormikField name={name} validate={validate}>
            {({ field, form }) => (
              <ClickFileInput
                {...otherProps}
                {...field}
                onChange={(evt) => {
                  form.setFieldValue(name, evt.target.files[0]);
                  onChange && onChange(evt);
                }}
                onBlur={() => {
                  form.setFieldTouched(name, true);
                }}
                onRemove={() => {
                  form.setFieldValue(name, undefined);
                }}
              />
            )}
          </FormikField>
          <div className={styles.errorMessage}>
            <FormikErrorMessage name={name} />
          </div>
        </div>
      );
    }
    return <ClickFileInput {...otherProps} name={name} onChange={onChange} />;
  },
);

const ClickFileInput = forwardRef(
  ({ id, name, label, accept, onChange, onBlur, onRemove }, _ref) => {
    const [imageSrc, setImageSrc] = useState(null);
    const [fileName, setFileName] = useState(null);
    const inputRef = useRef(null);

    const handleRemove = () => {
      setImageSrc(null);
      setFileName(null);

      if (inputRef.current) inputRef.current.value = "";

      if (onRemove) onRemove();
    };

    return (
      <div className={styles.wrapper}>
        <span className={styles.previewContainer}>
          {inputRef.current && inputRef.current.value ? (
            <>
              <button type="button" onClick={handleRemove}>
                <FontAwesomeIcon icon="times" />
              </button>

              {imageSrc ? (
                <img className={styles.preview} alt="" src={imageSrc} />
              ) : (
                <div className={styles.filePreview}>
                  <FontAwesomeIcon icon="folder" />
                </div>
              )}
            </>
          ) : (
            <></>
          )}
        </span>
        {fileName && <span className={styles.name}>{fileName}</span>}
        <input
          value={undefined}
          name={name}
          ref={inputRef}
          id={id}
          type="file"
          accept={accept}
          onBlur={onBlur}
          onChange={(evt) => {
            const file = evt.target.files[0];

            if (file) {
              setFileName(file.name);

              if (accept === "image/*") {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.addEventListener(
                  "load",
                  () => {
                    setImageSrc(reader.result);
                  },
                  false,
                );
              }
            } else {
              handleRemove();
            }

            onChange(evt);
          }}
        />
        <label htmlFor={id}>
          <div className={styles.icon}>
            <FontAwesomeIcon icon="folder-open" />
          </div>
          <div className={styles.label}>{label}</div>
        </label>
      </div>
    );
  },
);

export default ClickFileInputWithFormik;
